// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-input__inner[data-v-1af798ec]{border:1px solid #c0c4cc!important}.table-content[data-v-1af798ec]{border:1px solid #f8f8ff!important;overflow-x:hidden;height:450px!important}[data-v-1af798ec] .el-table__body-wrapper{max-height:350px;overflow-y:auto!important;overflow-x:auto}", ""]);
// Exports
module.exports = exports;
